import BotStatusComponent from './bot-status';

export default BotStatusComponent; 